<template>
  <div class="mt-3 mb-3">
    <div class="row mb-3">
      <div class="col-6">
        <b-input style="max-width: 250px" placeholder="Filtrar"></b-input>
      </div>
      <div class="col-6 text-right">
        <b-btn variant="info" @click="openForm(null)"
          ><i class="fa fa-plus" /> Adicionar</b-btn
        >
      </div>
    </div>
    <hr />
    <b-table
      :items="lista"
      :fields="[
        { label: 'Codigo', key: 'id' },
        { label: 'Aplicativo', key: 'nome' },
        { label: 'Tipo', key: 'tipo' },
        { label: 'Ativo', key: 'status' },
        { label: '', key: 'opc' },
      ]"
      hover
      selection-mode="single"
      selectable
      large
      @row-clicked="openForm"
    >
      <template #cell(status)="row">
        <div class="d">
          <b-checkbox switch value="1" v-model="row.item.status">
            Status
            <i class="fa fa-check-circle text-success" v-if="row.item.status == 1" />
            <i class="fa fa-times-circle text-danger" v-if="row.item.status != 1" />
          </b-checkbox>
        </div>
      </template>
      <template #cell(opc)="row">
        <i class="fa fa-edit cursor" @click="openForm(row.item)"></i>
        <i class="fa fa-trash cursor ml-2" @click="delet(row.item)"></i>
      </template>
    </b-table>
    <b-modal
      id="modal-edit-app"
      size="lg"
      no-fade
      content-class="prodModal"
      hide-footer
      title="Adicionar/Editar Aplicativo"
    >
      <div class="row" v-if="objEdit">
        <div class="col-2">
          <file-upload
            :value="objEdit.logo"
            v-model="objEdit.logo"
            :maxFiles="1"
            :enableTitle="false"
          ></file-upload>
          <div class="mt-2">
            <label>Status</label>
            <b-checkbox switch v-model="objEdit.status" value="1">Ativo</b-checkbox>
          </div>
        </div>
        <div class="col">
          <div>
            <label>Nome / Referencia</label>
            <b-input v-model="objEdit.nome"></b-input>
          </div>
          <div class="d-flex">
            <div style="min-width: 150px">
              <label>Tipo</label>
              <div>
                <b-select
                  :options="['Cardápio Digital', 'Mesa/Salão', 'Delivery']"
                  v-model="objEdit.tipo"
                  style="max-width: 200px"
                />
              </div>
            </div>
            <div class="ml-2" style="flex: 1">
              <label>URL</label>
              <div class="">
                <div>
                  <b-input v-model="objEdit.url" />

                  <b-button @click="generateUrl" class="mt-2 mr-2">Gerar URL</b-button>
                  <b-button @click="generateQrCode" class="mt-2">Gerar QR Code</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 text-center">
          <div v-if="qrValue && qrValue.trim() != ''">
            <img :src="imgQrcode" alt="qrcode" v-if="imgQrcode" />
            <div>
              <b-button @click="downloadQrCode" class="mt-2">Download</b-button>
              <b-button @click="imprimirQrCode" class="mt-2 ml-2">Imprimir</b-button>
            </div>
            <vue-qrcode
              :value="qrValue"
              :color="{ dark: '#000000ff', light: '#ffffffff' }"
              type="image/png"
              :width="200"
              :version="10"
              :scale="3"
              :quality="1"
              :errorCorrectionLevel="'H'"
              :margin="4"
              :qrcfg="{ ec_level: 'H', margin: 4 }"
              :logo="require('@/assets/logo.png')"
              @change="onDataUrlChange"
              @error="handleQrcodeError"
            />
          </div>
        </div>
        <div class="col-12">
          <b-tabs>
            <b-tab>
              <template v-slot:title>
                <i class="fa fa-calendar mr-1" /> Horários
              </template>
              <b-card class="m-4">
                <h4><b-icon-phone /> Gerenciamento de Aplicativo</h4>
                <div class="row">
                  <div class="col-12"></div>
                  <div class="col-6 mt-3">
                    <label><b-icon-clock /> Horário de Funcionamento</label>
                    <div class="row">
                      <div class="col-6">
                        <b-input type="time" v-model="objEdit.funcionamento.inicio" />
                      </div>
                      <div class="col-6">
                        <b-input type="time" v-model="objEdit.funcionamento.fim" />
                      </div>
                    </div>
                  </div>
                  <div class="col-6 mt-3">
                    <label><b-icon-palette /> Configurações de Cores</label>
                    <div class="row">
                      <div class="col-12 mb-2">
                        <label class="small">Cor Primária</label>
                        <b-input
                          type="color"
                          v-model="objEdit.cores.primaria"
                          style="height: 40px"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <label class="small">Cor Secundária</label>
                        <b-input
                          type="color"
                          v-model="objEdit.cores.secundaria"
                          style="height: 40px"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <label class="small">Cor de Fundo</label>
                        <b-input
                          type="color"
                          v-model="objEdit.cores.fundo"
                          style="height: 40px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="fa fa-layer-group mr-1"></i>Categorias
              </template>

              <!-- Lista de Categorias em Cards -->
              <div class="categorias-container">
                <transition-group name="categoria-move" tag="div">
                  <div
                    v-for="(categoria, index) in categorias"
                    :key="`categoria-${categoria.id || index}`"
                    class="categoria-card"
                    :class="{
                      'categoria-moving': movingIndex === index,
                      'categoria-highlight': highlightIndex === index,
                    }"
                  >
                    <b-card class="h-100 shadow-sm border-0">
                      <!-- Header do Card -->
                      <div
                        class="categoria-header d-flex justify-content-between align-items-center mb-3"
                      >
                        <h6 class="card-title mb-0">
                          <i class="fa fa-layer-group text-primary mr-2"></i>
                          Categoria {{ categoria.nome || index + 1 }}
                        </h6>
                        <div class="categoria-actions">
                          <b-btn
                            variant="outline-primary"
                            size="sm"
                            @click="moveCategoriaUp(index)"
                            :disabled="index === 0"
                            class="mr-1"
                            title="Mover para cima"
                          >
                            <i class="fa fa-arrow-up"></i>
                          </b-btn>
                          <b-btn
                            variant="outline-primary"
                            size="sm"
                            @click="moveCategoriaDown(index)"
                            :disabled="index === categorias.length - 1"
                            class="mr-1"
                            title="Mover para baixo"
                          >
                            <i class="fa fa-arrow-down"></i>
                          </b-btn>
                          <b-btn
                            variant="outline-danger"
                            size="sm"
                            @click="deleteCategoria(index)"
                            title="Excluir categoria"
                          >
                            <i class="fa fa-trash"></i>
                          </b-btn>
                        </div>
                      </div>

                      <!-- Conteúdo do Card -->
                      <div class="categoria-content-horizontal">
                        <div class="row">
                          <!-- Ícone -->
                          <div class="col-md-2">
                            <label class="form-label">
                              <i class="fa fa-image mr-1"></i>Ícone
                            </label>
                            <div class="upload-container-small">
                              <file-upload
                                :value="categoria.icone"
                                v-model="categoria.icone"
                                :maxFiles="1"
                                :enableTitle="false"
                                :key="'fileupd-icon-' + index + '-' + Math.random()"
                              />
                            </div>
                          </div>
                          <!-- Nome da Categoria -->
                          <div class="col-md-10">
                            <div class="row">
                              <div class="col-md-12">
                                <label class="form-label">
                                  <i class="fa fa-toggle-on mr-1"></i>Status
                                </label>
                                <div class="mt-2">
                                  <b-checkbox
                                    switch
                                    value="1"
                                    v-model="categoria.status"
                                    class="categoria-switch"
                                  >
                                    {{ categoria.status ? "Ativo" : "Inativo" }}
                                  </b-checkbox>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label class="form-label">
                                  <i class="fa fa-tag mr-1"></i>Nome
                                </label>
                                <b-input
                                  v-model="categoria.nome"
                                  placeholder="Nome da categoria"
                                  class="form-control-modern"
                                />
                              </div>

                              <div class="col-md-6">
                                <label class="form-label">
                                  <i class="fa fa-list mr-1"></i>Grupos
                                </label>
                                <v-select
                                  v-model="categoria.categorias"
                                  multiple
                                  label="Grupo"
                                  :options="grupos"
                                  :reduce="(it) => it.cod_grupo"
                                  @input="onCategoriaChange(categoria, $event)"
                                  placeholder="Selecione os grupos"
                                  class="v-select-modern"
                                />
                              </div>
                            </div>
                          </div>

                          <!-- Status -->

                          <!-- Grupos/Categorias -->

                          <!-- Imagem
                        <div class="col-md-2">
                          <label class="form-label">
                            <i class="fa fa-picture-o mr-1"></i>Imagem
                          </label>
                          <div class="upload-container-small">
                            <file-upload
                              :value="categoria.imagem"
                              v-model="categoria.imagem"
                              :maxFiles="1"
                              :enableTitle="false"
                              :key="'fileupd-img-' + index + '-' + Math.random()"
                            />
                          </div>
                        </div> -->
                        </div>
                      </div>
                    </b-card>
                  </div>

                  <!-- Card para Adicionar Nova Categoria -->
                  <div class="categoria-card categoria-add-card">
                    <b-card class="shadow-sm border-2 border-dashed categoria-add-new">
                      <div
                        class="add-categoria-content-horizontal d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center">
                          <i class="fa fa-plus-circle fa-2x text-muted mr-3"></i>
                          <div>
                            <h6 class="text-muted mb-0">Adicionar Nova Categoria</h6>
                            <small class="text-muted"
                              >Clique para criar uma nova categoria</small
                            >
                          </div>
                        </div>
                        <b-btn
                          variant="outline-primary"
                          @click="addCategoria"
                          class="btn-add-categoria-horizontal"
                        >
                          <i class="fa fa-plus mr-2"></i>Criar
                        </b-btn>
                      </div>
                    </b-card>
                  </div>
                </transition-group>
                <div>
                  <b-button variant="info" class="m-4" @click="addCategoria"
                    ><i class="fa fa-plus"></i> Adicionar Categoria</b-button
                  >
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title> <i class="fa fa-images"></i> Banners </template>

              <b-table
                :items="banners"
                :fields="[
                  { label: 'Nome', key: 'nome' },
                  { label: 'Status', key: 'status' },
                  { label: 'Imagem', key: 'imagem', class: 'colRedu' },
                  { label: '', key: 'opc' },
                ]"
              >
                <template #cell(imagem)="row">
                  <div style="max-width: 200px">
                    <file-upload
                      :value="row.item.imagem"
                      v-model="row.item.imagem"
                      :maxFiles="1"
                      :enableTitle="false"
                      :key="'fileupd' + Math.random()"
                    />
                  </div>
                </template>
                <template #cell(nome)="row">
                  <b-input v-model="row.item.nome" placeholder="Nome" />
                </template>

                <template #cell(status)="row">
                  <b-checkbox switch value="1" v-model="row.item.status"
                    >Ativo</b-checkbox
                  >
                </template>
              </b-table>
              <div class="text-right">
                <b-btn variant="info" @click="addBanner"
                  ><i class="fa fa-plus"></i> Add. Banner</b-btn
                >
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="fa fa-star mr-1"></i>Programas de Fidelização
              </template>

              <div class="p-5">
                <div class="row">
                  <div
                    class="col-12 col-md-4"
                    v-for="fidel in fidelizacoes"
                    :key="`fidel${fidel.tipo}`"
                  >
                    <b-card style="min-height: 280px">
                      <b-card-title>
                        <div class="d-flex justify-content-between">
                          <h5><i class="fa fa-star mr-2"></i>{{ fidel.tipo }}</h5>
                        </div>
                      </b-card-title>
                      <b-card-text>
                        <small>{{ fidel.descricao }}</small>
                      </b-card-text>
                      <b-card-footer class="d-flex justify-content-between">
                        <b-checkbox v-model="fidel.ativo" switch>Ativo</b-checkbox>
                        <b-btn @click="editFidel(fidel)">Configurar</b-btn>
                      </b-card-footer>
                    </b-card>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <hr />
      <div class="text-right">
        <b-btn class="mr-1" variant="success" @click="salvar"
          ><i class="fa fa-save" /> Salvar</b-btn
        >
        <b-btn variant="secondary" @click="cancelar"
          ><i class="fa fa-ban" /> Cancelar</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      id="modal-edit-fidel"
      hide-footer
      :title="objFidel.tipo"
      v-if="objFidel"
      size="lg"
    >
      <h4>Prêmios</h4>
      <hr />
      <div class="row">
        <div class="col-12" v-if="objFidel && objFidel.obj && objFidel.obj.premios">
          <aplicativo-fidelizacao-premios
            v-if="objFidel.obj"
            :objEdit="objFidel.obj"
          ></aplicativo-fidelizacao-premios>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import ProdutoGrupoLib from "../../libs/ProdutoGrupoLib";
import FileUpload from "../common/FileUpload.vue";
import AplicativoFidelizacaoPremios from "./AplicativoFidelizacaoPremios.vue";
import { fidelizacoes as fidels } from "./tiposFidelizacao";

const refObj = {
  nome: "",
  categorias: [],
  status: 0,
  logo: [],
  banners: [],
  fidelizacoes: [],
  funcionamento: {
    inicio: "00:00",
    fim: "23:59",
  },
  cores: {
    primaria: "#007bff",
    secundaria: "#6c757d",
    fundo: "#ffffff",
  },
};
export default {
  components: { FileUpload, AplicativoFidelizacaoPremios, VueQrcode },
  props: {
    dados: Array,
  },
  mounted() {
    this.carregarGrupos();
    this.lista = JSON.parse(JSON.stringify(this.dados)) || [];
  },
  data() {
    return {
      objEdit: null,
      editing: false,
      grupos: [],
      lista: [],
      categorias: [],
      banners: [],
      fidelizacoes: Object.assign([], [...fidels]),
      objFidel: null,
      movingIndex: null,
      highlightIndex: null,
      imgQrcode: null,
      qrValue: null,
    };
  },
  watch: {
    lista: {
      deep: true,
      handler() {
        this.$emit("change", this.lista);
      },
    },
    categorias: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  computed: {},
  methods: {
    imprimirQrCode() {
      if (this.imgQrcode && this.imgQrcode.trim() !== "") {
        const printWindow = window.open("", "_blank");
        // Construir o documento do printWindow usando DOM APIs em vez de document.write (deprecated)
        const doc = printWindow.document;
        doc.open();

        const html = doc.createElement("html");

        const head = doc.createElement("head");
        const title = doc.createElement("title");
        title.textContent = "Imprimir QR Code";
        head.appendChild(title);

        const style = doc.createElement("style");
        style.type = "text/css";
        style.appendChild(
          doc.createTextNode(
            `@media print {
              body {
                margin: 0;
                padding: 0;
                text-align: center;
              }
              img {
                max-width: 100%;
                height: auto;
              }
            }`
          )
        );
        head.appendChild(style);
        html.appendChild(head);

        const bodyEl = doc.createElement("body");

        const img = doc.createElement("img");
        img.src = this.imgQrcode;
        img.alt = "QR Code";
        bodyEl.appendChild(img);

        const script = doc.createElement("script");
        script.type = "text/javascript";
        script.appendChild(
          doc.createTextNode(
            "window.onload = function() { window.print(); window.onafterprint = function() { window.close(); } }"
          )
        );
        bodyEl.appendChild(script);

        html.appendChild(bodyEl);

        if (doc.documentElement) {
          doc.replaceChild(html, doc.documentElement);
        } else {
          doc.appendChild(html);
        }

        doc.close();
      } else {
        this.$swal.fire({
          title: "Atenção!",
          text: "Nenhum QR Code disponível para impressão.",
          icon: "warning",
        });
      }
    },
    downloadQrCode() {
      const link = document.createElement("a");
      link.href = this.imgQrcode;
      link.download = "qrcode.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    generateUrl() {
      this.objEdit.url = window.location.origin + (this.objEdit.tipo == 'Mesa/Salão' ? "/app-mesa" : "/app");
      this.$forceUpdate();
    },
    generateQrCode() {
      if (this.objEdit && this.objEdit.url && this.objEdit.url.trim() !== "") {
        // Limpar estado anterior para evitar loops
        this.imgQrcode = null;

        // Gerar novo QR Code
        this.qrValue = this.objEdit.url.trim();
      } else {
        this.$swal.fire({
          title: "Atenção!",
          text: "Informe uma URL válida para gerar o QR Code.",
          icon: "warning",
        });
      }
    },
    handleQrcodeError(error) {
      console.error("QR Code Error:", error);
    },
    onDataUrlChange(dataUrl) {
      console.log("dataUrl", dataUrl);
      this.imgQrcode = dataUrl;
      // Removido $forceUpdate() que estava causando loop infinito
    },
    editFidel(fidel) {
      this.objFidel = fidel;
      this.$bvModal.show("modal-edit-fidel");
    },
    salvar() {
      let err = [];
      if (!this.objEdit.nome) {
        err.push("Informe um nome!");
      }
      if (!this.objEdit.tipo) {
        err.push("Informe um tipo");
      }
      if (!this.categorias || this.categorias.length <= 0) {
        err.push("Adicione uma categoria!");
      }

      if (err.length > 0) {
        this.$swal({
          title: "Atenção!",
          html: "Alguns campos precisam de atenção: <hr/>" + err.join("<hr/>"),
          icon: "error",
        });
      } else {
        this.objEdit.categorias = JSON.parse(JSON.stringify(this.categorias));
        this.objEdit.banners = this.banners
          ? JSON.parse(JSON.stringify(this.banners))
          : [];
        this.objEdit.fidelizacoes = this.fidelizacoes
          ? JSON.parse(JSON.stringify(this.fidelizacoes))
          : [];
        if (!this.objEdit.funcionamento) {
          this.objEdit.funcionamento = {
            inicio: "00:00",
            fim: "23:59",
          };
        }
        if (!this.objEdit.cores) {
          this.objEdit.cores = {
            primaria: "#007bff",
            secundaria: "#6c757d",
            fundo: "#ffffff",
          };
        }
        if (!this.editing) {
          this.objEdit.id =
            this.lista && this.lista.length > 0
              ? this.lista.sort((a, b) => b.id - a.id)[0].id + 1
              : 1;
          this.lista.push(this.objEdit);
        } else {
          let hasidx = this.lista.findIndex((x) => x.id == this.objEdit.id);
          this.lista[hasidx] = JSON.parse(JSON.stringify(this.objEdit));
        }
        this.$bvModal.hide("modal-edit-app");
        this.$forceUpdate();
        this.lista = this.lista.filter((x) => x == x);
      }
      console.log("this.objEdit", this.objEdit);
      setTimeout(() => {
        this.$set(this.lista, "lista");
        this.lista = this.lista.filter((x) => x == x);

        this.$nextTick();
        this.$forceUpdate();
      }, 200);
    },
    cancelar() {
      this.$bvModal.hide("modal-edit-app");
    },
    async carregarGrupos() {
      this.grupos = await ProdutoGrupoLib.get();
      console.log("grupos", this.grupos);
    },
    delet(obj) {
      this.$swal({
        title: "Tem certeza que deseja excluir esta configuração?",
        icon: "question",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((x) => {
        if (x.isConfirmed) {
          this.lista = this.lista.filter((x) => x != obj);
        }
      });
    },
    openForm(obj) {
      console.log("this.objEdit", obj);

      if (!obj) {
        this.editing = false;

        obj = Object.assign({}, { ...refObj });
        this.categorias = [];
      } else {
        this.categorias = JSON.parse(JSON.stringify(obj.categorias));
        this.banners = obj.banners ? JSON.parse(JSON.stringify(obj.banners)) : [];
        this.fidelizacoes = obj.fidelizacoes
          ? JSON.parse(JSON.stringify(obj.fidelizacoes))
          : Object.assign([], [...fidels]);
        this.editing = true;
        if (obj.url && obj.url.trim() !== "") {
          this.qrValue = obj.url.trim();
        } else {
          this.qrValue = null;
          this.imgQrcode = null;
        }
      }
      this.objEdit = JSON.parse(JSON.stringify(obj));
      if (!this.objEdit.funcionamento) {
        this.objEdit.funcionamento = {
          inicio: "00:00",
          fim: "23:59",
        };
      }
      if (!this.objEdit.cores) {
        this.objEdit.cores = {
          primaria: "#007bff",
          secundaria: "#6c757d",
          fundo: "#ffffff",
        };
      }
      if (!this.objEdit.fone) {
        this.objEdit.fone = "";
      }
      this.$forceUpdate();

      this.$bvModal.show("modal-edit-app");
    },
    addBanner() {
      if (!this.objEdit) {
        console.log("objedit error", this.objEdit);
        this.objEdit = Object.assign({}, { ...refObj });
      }
      if (!this.objEdit.banners) {
        console.log("objedit error cat", this.objEdit);

        this.objEdit.banners = [];
      }
      if (!this.banners) {
        this.banners = [];
      }
      this.banners.push({
        imagem: [],
        nome: "",
        status: 0,
      });

      this.$forceUpdate();
    },
    addCategoria() {
      if (!this.objEdit) {
        console.log("objedit error", this.objEdit);
        this.objEdit = Object.assing({}, { ...refObj });
      }
      if (!this.objEdit.categorias) {
        console.log("objedit error cat", this.objEdit);

        this.objEdit.categorias = [];
      }
      if (!this.categorias) {
        this.categorias = [];
      }
      this.categorias.push({
        id: Date.now() + Math.random(), // ID único para animações
        icone: [],
        imagem: [],
        nome: "",
        status: 0,
        categorias: [],
      });
      console.log("objedit added", this.objEdit, this.categorias);

      this.$forceUpdate();
    },
    moveCategoriaUp(index) {
      if (index > 0) {
        // Destacar o item que está sendo movido
        this.movingIndex = index;
        this.highlightIndex = index - 1;

        // Pequeno delay para mostrar o efeito visual
        setTimeout(() => {
          const item = this.categorias[index];
          this.categorias.splice(index, 1);
          this.categorias.splice(index - 1, 0, item);

          // Limpar destaque após movimento
          setTimeout(() => {
            this.movingIndex = null;
            this.highlightIndex = null;
          }, 300);
        }, 150);
      }
    },
    moveCategoriaDown(index) {
      if (index < this.categorias.length - 1) {
        // Destacar o item que está sendo movido
        this.movingIndex = index;
        this.highlightIndex = index + 1;

        // Pequeno delay para mostrar o efeito visual
        setTimeout(() => {
          const item = this.categorias[index];
          this.categorias.splice(index, 1);
          this.categorias.splice(index + 1, 0, item);

          // Limpar destaque após movimento
          setTimeout(() => {
            this.movingIndex = null;
            this.highlightIndex = null;
          }, 300);
        }, 150);
      }
    },
    deleteCategoria(index) {
      this.$swal({
        title: "Tem certeza?",
        text: "Deseja excluir esta categoria?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.categorias.splice(index, 1);
          this.$forceUpdate();
          this.$swal("Excluído!", "A categoria foi removida.", "success");
        }
      });
    },
    onCategoriaChange(categoria, selectedCategorias) {
      // Se há categorias selecionadas e a categoria não tem ícone ainda
      if (
        selectedCategorias &&
        selectedCategorias.length > 0 &&
        (!categoria.icone || categoria.icone.length === 0)
      ) {
        // Pegar o primeiro grupo selecionado
        const primeiroGrupoId = selectedCategorias[0];
        const primeiroGrupo = this.grupos.find(
          (grupo) => grupo.cod_grupo === primeiroGrupoId
        );

        // Se o primeiro grupo tem ícone, copiar para a categoria
        if (primeiroGrupo && primeiroGrupo.icone) {
          categoria.icone = Array.isArray(primeiroGrupo.icone)
            ? [...primeiroGrupo.icone]
            : [primeiroGrupo.icone];
          this.$forceUpdate();
        }
      }
    },
  },
};
</script>
<style>
  .vs__dropdown-menu {
    max-height: 150px !important;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

</style>
<style lang="scss" scoped>
.colRedu {
  max-width: 200px !important;
}

// Animações de transição para movimentação de categorias
.categoria-move-enter-active,
.categoria-move-leave-active {
  transition: all 0.5s ease;
}

.categoria-move-enter {
  opacity: 0;
  transform: translateY(-30px);
}

.categoria-move-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.categoria-move-move {
  transition: transform 0.5s ease;
}

// Estados de movimentação e destaque
.categoria-moving {
  transform: scale(1.02) !important;
  z-index: 10;

  .card {
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
    border: 2px solid #4e73df !important;
    box-shadow: 0 0.75rem 1.5rem rgba(78, 115, 223, 0.3) !important;
    animation: pulse-move 0.6s ease-in-out;
  }
}

.categoria-highlight {
  .card {
    background: linear-gradient(135deg, #fff3e0 0%, #fce4ec 100%);
    border: 2px solid #ff9800 !important;
    animation: highlight-pulse 0.6s ease-in-out;
  }
}

// Animações keyframes
@keyframes pulse-move {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1.02);
  }
}

@keyframes highlight-pulse {
  0% {
    background: linear-gradient(135deg, #f8f9fc 0%, #eaecf4 100%);
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  }
  50% {
    background: linear-gradient(135deg, #fff3e0 0%, #fce4ec 100%);
    box-shadow: 0 0.5rem 1rem rgba(255, 152, 0, 0.3);
  }
  100% {
    background: linear-gradient(135deg, #fff3e0 0%, #fce4ec 100%);
    box-shadow: 0 0.25rem 0.5rem rgba(255, 152, 0, 0.2);
  }
}

// Estilização da área de categorias
.categorias-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
}

.categoria-card {
  transition: all 0.3s ease-in-out;
  position: relative;
  min-height: 350px !important;
  margin-bottom: 20px;

  &:hover:not(.categoria-moving):not(.categoria-highlight) {
    transform: translateY(-2px);
  }

  .card {
    border-radius: 12px;
    border: 1px solid #e3e6f0;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    min-height: 350px !important;


    &:hover {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    }

    // Efeito de ondulação sutil
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
      );
      transition: left 0.5s ease;
      z-index: 1;
    }

    &:hover::before {
      left: 100%;
    }
  }
}

.categoria-header {
  border-bottom: 1px solid #e3e6f0;
  padding-bottom: 0.75rem;

  .card-title {
    color: #5a5c69;
    font-weight: 600;
  }
}

.categoria-actions {
  .btn {
    border-radius: 8px;
    padding: 0.25rem 0.5rem;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      animation: button-click 0.3s ease;
    }

    // Efeito especial para botões de movimento
    &[title*="Mover"] {
      &:active {
        animation: move-button-pulse 0.4s ease;
      }
    }
  }
}

@keyframes button-click {
  0% {
    transform: scale(1.05);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1.05);
  }
}

@keyframes move-button-pulse {
  0% {
    transform: scale(1.05);
    box-shadow: 0 0 0 0 rgba(78, 115, 223, 0.7);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 10px rgba(78, 115, 223, 0);
  }
  100% {
    transform: scale(1.05);
    box-shadow: 0 0 0 0 rgba(78, 115, 223, 0);
  }
}

.categoria-content {
  .form-label {
    font-weight: 600;
    color: #5a5c69;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;

    i {
      color: #858796;
    }
  }

  .form-control-modern {
    border-radius: 8px;
    border: 1px solid #d1d3e2;
    padding: 0.75rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4e73df;
      box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);
    }
  }

  .categoria-switch {
    .custom-control-label {
      font-weight: 500;
      color: #5a5c69;
    }
  }

  .v-select-modern {
    .vs__dropdown-toggle {
      border-radius: 8px;
      border: 1px solid #d1d3e2;
      padding: 0.5rem;
    }

    .vs__selected-options {
      padding: 0.25rem 0;
    }

    .vs__search {
      padding: 0.5rem 0;
    }
  }

  .upload-container {
    border: 2px dashed #d1d3e2;
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    transition: all 0.3s ease;
    background-color: #f8f9fc;

    &:hover {
      border-color: #4e73df;
      background-color: #f0f3ff;
    }
  }
}

// Layout horizontal para categorias
.categoria-content-horizontal {
  .form-label {
    font-weight: 600;
    color: #5a5c69;
    font-size: 0.8rem;
    margin-bottom: 0.3rem;

    i {
      color: #858796;
    }
  }

  .form-control-modern {
    border-radius: 6px;
    border: 1px solid #d1d3e2;
    padding: 0.5rem;
    font-size: 0.875rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4e73df;
      box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);
    }
  }

  .categoria-switch {
    .custom-control-label {
      font-weight: 500;
      color: #5a5c69;
      font-size: 0.8rem;
    }
  }

  .v-select-modern {
    .vs__dropdown-toggle {
      border-radius: 6px;
      border: 1px solid #d1d3e2;
      padding: 0.3rem;
      min-height: 38px;
    }

    .vs__selected-options {
      padding: 0.1rem 0;
    }

    .vs__search {
      padding: 0.3rem 0;
      font-size: 0.875rem;
    }

    .vs__selected {
      font-size: 0.75rem;
    }
  }

  .upload-container-small {
    border: 2px dashed #d1d3e2;
    border-radius: 6px;
    padding: 0.5rem;
    text-align: center;
    transition: all 0.3s ease;
    background-color: #f8f9fc;
    min-height: 60px;
    // display: flex;
    // align-items: center;
    // justify-content: center;

    &:hover {
      border-color: #4e73df;
      background-color: #f0f3ff;
    }
  }

  .row {
    margin: 0 -0.5rem;

    [class*="col-"] {
      padding: 0 0.5rem;
    }
  }
}

// Card para adicionar nova categoria
.categoria-add-card {
  .categoria-add-new {
    background: linear-gradient(135deg, #f8f9fc 0%, #eaecf4 100%);
    border: 2px dashed #d1d3e2 !important;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    padding: 1rem;

    &:hover {
      border-color: #4e73df !important;
      background: linear-gradient(135deg, #f0f3ff 0%, #e3e9ff 100%);
      transform: translateY(-1px);
    }
  }

  .add-categoria-content {
    padding: 2rem 1rem;

    i {
      transition: all 0.3s ease;
    }

    &:hover i {
      color: #4e73df !important;
      transform: scale(1.1);
    }
  }

  .add-categoria-content-horizontal {
    padding: 0.5rem 0;

    i {
      transition: all 0.3s ease;
    }

    &:hover i {
      color: #4e73df !important;
      transform: scale(1.05);
    }
  }

  .btn-add-categoria {
    border-radius: 25px;
    padding: 0.75rem 1.5rem;
    font-weight: 600;
    border: 2px solid #4e73df;
    background: transparent;
    color: #4e73df;
    transition: all 0.3s ease;

    &:hover {
      background: #4e73df;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 0.25rem 0.5rem rgba(78, 115, 223, 0.3);
    }
  }

  .btn-add-categoria-horizontal {
    border-radius: 20px;
    padding: 0.5rem 1rem;
    font-weight: 600;
    border: 2px solid #4e73df;
    background: transparent;
    color: #4e73df;
    transition: all 0.3s ease;
    font-size: 0.875rem;

    &:hover {
      background: #4e73df;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 0.25rem 0.5rem rgba(78, 115, 223, 0.3);
    }
  }
}

// Responsividade
@media (max-width: 768px) {
  .categoria-content-horizontal {
    .row {
      flex-direction: column;

      [class*="col-"] {
        max-width: 100%;
        flex: 0 0 100%;
        margin-bottom: 1rem;
      }
    }
  }

  .add-categoria-content-horizontal {
    flex-direction: column !important;
    text-align: center;
    gap: 1rem;

    .d-flex {
      flex-direction: column;
    }
  }
}

@media (max-width: 576px) {
  .categoria-actions {
    .btn {
      padding: 0.2rem 0.4rem;
      font-size: 0.8rem;
    }
  }

  .categoria-content {
    .row {
      margin: 0 -0.5rem;

      .col-6 {
        padding: 0 0.5rem;
      }
    }
  }
}

  .vs__dropdown-menu {
    max-height: 150px !important;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

</style>
